import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDutchFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#fff"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				fill: "#a2001d",
				x: 0,
				y: 0,
				width: 512,
				height: 167
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#fff",
				x: 0,
				y: 167,
				width: 512,
				height: 178
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0052b4",
				x: 0,
				y: 345,
				width: 512,
				height: 167
			})
		]
	})]
});
export default SvgDutchFlag;
